import React from 'react';
import PropTypes from 'prop-types';
import {Modal} from '@learningblocks/shared-components/lib/Modal';
import {Heading} from './Heading';
import {CloseButton} from './CloseButton';
import {Content} from './Content';
import {MoveMenuContext} from '..';
import { Log } from '@learningblocks/shared-components/lib/EventLogger';

import styles from './style.module.scss';

export function ModalWindow(props) {
  const {running} = React.useContext(MoveMenuContext);
  return (
    <Modal
      className={styles.move_menu_modal}
      isOpen={props.modalOpen}
      close={props.toggleModal}
      size={'sim'}
      closeButton={false}
      notebookExpanded={props.notebookExpanded}
      lang={props.lang}
      >
        <Log
          logImpression={true}
          component={props.componentString}
          event_type= "sim_protocol_movemenu open"
          event_schema= "moveMenu"
          
        >
          <div className={styles.heading_wrapper}>
            <Heading
                component={props.component}
                componentString={props.componentString}
                type={props.type}
                typeString={props.typeString}
            />
            <CloseButton close={props.toggleModal} />
          </div>
          <Content
            component={props.component}
            type={props.type}
            connect={props.connect}
            targetList={props.targetList}
            interactionProps={props.interactionProps}
            setHeldObject={props.setHeldObject}
            calculatePosition={props.calculatePosition}
            teleport={props.teleport}
            toggleModal={props.toggleModal}

            setHeld={props.setHeld}
            setGelHeld={props.setGelHeld}
            setPowerSupplyLeadHeld={props.setPowerSupplyLeadHeld}
            setFlaskHeld={props.setFlaskHeld}
            setSolutionHeld={props.setSolutionHeld}
            setFloatingTubeRackHeld={props.setFloatingTubeRackHeld}
            setCellSpreaderHeld={props.setCellSpreaderHeld}
            setLabTapeHeld={props.setLabTapeHeld}
            setPetridishHeld={props.setPetridishHeld}
            setWasteCollectionJarHeld={props.setWasteCollectionJarHeld}
          />
        </Log>
    </Modal>
  );
}

ModalWindow.propTypes = {
  /**
   * specifies if modal window is open
   */
  modalOpen: PropTypes.bool,
  /**
   * callback function to trigger modal window open and close
   */
  toggleModal: PropTypes.func,

  //...Content.propTypes,
};
ModalWindow.defaulProps = {
  running: false,
};
